import { configureStore } from '@reduxjs/toolkit';
import { languageSlice } from './slices/language';

export const store = configureStore({
    reducer: {
        language: languageSlice.reducer,
    },
});